import { motion } from "framer-motion";

const EASE = [0.2, 0.8, 0.2, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", once = true, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-10% 0px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SplitLines = ({ lines, className = "", delay = 0, stagger = 0.12, as = "h1", inView = false }) => {
  const Tag = motion[as];
  const trigger = inView ? { whileInView: "show", viewport: { once: true, margin: "-10% 0px" } } : { animate: "show" };
  return (
    <Tag
      className={className}
      initial="hidden"
      {...trigger}
      variants={{ hidden: {}, show: { transition: { staggerChildren: stagger, delayChildren: delay } } }}
    >
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span className="block" variants={{ hidden: { y: "115%" }, show: { y: 0, transition: { duration: 1.1, ease: EASE } } }}>
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Stagger = ({ children, className = "", stagger = 0.08 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-10% 0px" }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: stagger } } }}
  >
    {children}
  </motion.div>
);

export const Item = ({ children, className = "", y = 28 }) => (
  <motion.div className={className} variants={{ hidden: { opacity: 0, y }, show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } } }}>
    {children}
  </motion.div>
);
